export const DASHBOARD_GET_ALL = "V1_DASHBOARD_GET_ALL";
export const DASHBOARD_TIMEFRAME_DAILY_GET_ALL = "V1_DASHBOARD_TIMEFRAME_DAILY_GET_ALL";
export const DASHBOARD_TIMEFRAME_MONTHLY_GET_ALL = "V1_DASHBOARD_TIMEFRAME_MONTHLY_GET_ALL";